import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {Button, Result} from "antd";
import {batchPrintMode} from "../../util/BatchPrintMode";


function BatchPrinter()
{
    const { param } = useParams() as { param: string };
    const serviceCode:string  =     process.env.REACT_APP_SERVICE_NAME as string;
    const server:string       =     batchPrintMode(window.location.host);
    //const [windowState, setWindowState] = useState('focus');\
    console.log(window.location.host);
    console.log(server);


    function runExe()
    {
        const urlScheme = `Docuwiz://PRINT/${serviceCode}/${server}/${param}`;
        window.location.href = urlScheme;
    }

    function downloadFile()
    {
        const downloadSetup = `../../update/DocuwizSetup.zip`;
        window.open(downloadSetup);
    }

    function downloadManual()
    {
        const downloadManual = `../../update/docuwiz_setup_manual.pdf`;
        window.open(downloadManual);
    }

    useEffect(() => {
        document.title = `${process.env.REACT_APP_TITLE as string} (일괄인쇄/일괄다운로드)`;
        runExe();

        }, []);

    const containerStyle = {
        width:'100%',
        display: 'flex',
        justifyContent: 'center', // 가로 방향 가운데 정렬
        alignItems: 'center', // 세로 방향 가운데 정렬
        borderTop:'5px solid #3ae1ff'
    };

    const innerDivStyle = {

        marginBottom:'40px',


    };

    return (
        <div style={containerStyle}>
              <Result
                icon={<img style={{width:"250px"}} src={"../../image/batch_print/printer.jpg"}/>}
                title="일괄 인쇄 / 다운로드 프로그램 실행"
                extra={[
                    <div>일괄 인쇄 / 다운로드 기능은 설치를 진행해야합니다.</div>,
                    <div>프로그램 실행이 되지 않으면 아래 '다운로드' 버튼을 누르고 설치하고,</div>,
                    <div>설치가 완료되면 '실행' 버튼을 누르세요.</div>,
                    <div style={innerDivStyle}>(최초 설치 이후에는 자동으로 실행됩니다.)</div>,
                    <Button onClick={downloadFile} style={{width:'80px'}} type="primary" key="console">
                        다운로드
                    </Button>,
                    <Button onClick={runExe} style={{width:'80px'}} type="primary" key="console">
                        실행
                    </Button>,
                    <Button onClick={downloadManual} style={{width:'80px'}}key="buy">설치안내</Button>,
                ]}
                />
        </div>
    );

};

export default BatchPrinter;